import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export default function initPeople() {
    const containers = document.querySelectorAll('.people__slider');

    containers.forEach(container => {
        new Swiper(container, {
            modules: [Autoplay],
            slidesPerView: 'auto',
            spaceBetween: 16,
            loop: true,
            speed: 6000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
        });
    });
}
